import * as z from 'zod'
import { DSourceListItem, SourceListItem, SourceType } from '../SourceEntity.js'
import { GetApiContract, PostApiContract } from './ApiContract.js'
import { Insertable } from 'kysely'
import { Sources } from '../../db.js'
import { schemaBoolish } from './zodUtils.js'

const sourceTypeSchema = z.enum<SourceType[]>([
    'Cancellation',
    'Conversion',
    'InformationDocument',
    'Memorandum',
    'New commitments',
    'Offset',
    'Outcome',
    'Prospectus',
    'Publication',
    'PublicationWarrant',
    'Repayment',
    'Stabilisation',
    'Supplement',
    'Terms',
    'Update',
])

export const putSourceSchema = z.object({
    convertibleId: z.string().nullish(),
    internalComment: z.string().nullish(),
    issueId: z.string().nullish(),
    prId: z.string().nullish(),
    publishedDate: z.iso.datetime().nullish(),
    sourceType: sourceTypeSchema,
    sourceUrl: z.string().nullish(),
    title: z.string().nullish(),
    warrantId: z.string().nullish(),
})

export const getSourceListQueryParamSchema = z.union([
    z.object({ convertibleId: z.string() }),
    z.object({ issueId: z.string() }),
    z.object({ prId: z.string() }),
    z.object({ sourceUrl: z.string() }),
    z.object({ warrantId: z.string() }),
])

export interface GetSourceListRequest extends GetApiContract {
    QueryParameters: z.infer<typeof getSourceListQueryParamSchema>
    Response: Array<DSourceListItem>
    ResponseJson: Array<SourceListItem>
}

export const postSourceSchema = z.object({
    sourceType: sourceTypeSchema,
    convertibleId: z.string().nullish(),
    internalComment: z.string().nullish(),
    issueFields: z
        .object({
            statusStage: z.number().optional(),
            statusComplete: schemaBoolish.optional(),
        })
        .optional(),
    issueId: z.string().nullish(),
    prId: z.string().nullish(),
    publishedDate: z.string().nullish(),
    sourceUrl: z.string().nullish(),
    title: z.string().nullish(),
    warrantId: z.string().nullish(),
})

export interface PostSourceRequest extends PostApiContract {
    Body: z.infer<typeof postSourceSchema>
    Response: Insertable<Sources>
    ResponseJson: z.infer<typeof postSourceSchema>
}
